import { render } from "./InstrumentDetails.vue?vue&type=template&id=4f6b4709&scoped=true"
import script from "./InstrumentDetails.vue?vue&type=script&lang=js"
export * from "./InstrumentDetails.vue?vue&type=script&lang=js"

import "./InstrumentDetails.vue?vue&type=style&index=0&id=4f6b4709&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f6b4709"]])

export default __exports__